import NumberKeyboardElement from "./number-keyboard.js";
import NumberKeyboardButton from "./number-keyboard-button.js";
import NumberKeyboardHeader from "./number-keyboard-header.js";
import NumberKeyboardKey from "./number-keyboard-key.js";
import NumberKeyboardSidebar from "./number-keyboard-sidebar.js";
const NumberKeyboard = NumberKeyboardElement;
NumberKeyboard.Key = NumberKeyboardKey;
NumberKeyboard.Button = NumberKeyboardButton;
NumberKeyboard.Header = NumberKeyboardHeader;
NumberKeyboard.Sidebar = NumberKeyboardSidebar;
export default NumberKeyboard;
